import React from 'react';
import FashionIcon from '../FashionIcon';

export default function PrevArrow(props) {
  let { className, style, onClick, currentSlide, a11yProps, iconCssName } = props;

  if(currentSlide === 0) {
      style.display = 'none';
  }
  
  return (
    <button type="button" className={className} onClick={onClick} style={style} aria-label="move to previous card" {...a11yProps}>
      <FashionIcon name="caret_left" iconCssName={iconCssName}/>
    </button>
  );
}
